// src/components/ui/SheetDataTable.jsx

import React from 'react';
import { PAGE, getZebraRowStyle } from './pageTheme';
import { getStatusHex } from '../../utils/helpers';

export default function SheetDataTable({
  headers,
  rows,
  renderHeader = (h) => h,
  getCellValue = (row, header) => row[header] || '',
  statusColumnTest = () => false,
  highlightStatusValues = true,
  renderCell,
  minWidth = 900,
}) {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth }}>
      <thead>
        <tr style={{ borderBottom: `2px solid ${PAGE.colors.line}` }}>
          {headers.map(header => (
            <th
              key={header}
              style={{ ...PAGE.type.tableHead, color: PAGE.colors.heading }}
            >
              {renderHeader(header)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex} style={getZebraRowStyle(rowIndex)}>
            {headers.map(header => {
              if (renderCell) {
                return renderCell(row, header, rowIndex);
              }

              const value = getCellValue(row, header);
              const isStatus = statusColumnTest(header, value);
              const color = isStatus
                ? getStatusHex(value)
                : value
                  ? PAGE.colors.text
                  : PAGE.colors.muted;
              const valText = String(value).toLowerCase();
              const highlight =
                highlightStatusValues &&
                (valText.includes('good') || valText.includes('damaged'));

              return (
                <td
                  key={header}
                  style={{
                    ...PAGE.type.tableCell,
                    color,
                    fontWeight: highlight ? 600 : 400,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {value || '—'}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
